import { render, staticRenderFns } from "./OptimizerArea.vue?vue&type=template&id=b388f7d6&scoped=true&"
import script from "./OptimizerArea.vue?vue&type=script&lang=js&"
export * from "./OptimizerArea.vue?vue&type=script&lang=js&"
import style0 from "./OptimizerArea.vue?vue&type=style&index=0&id=b388f7d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b388f7d6",
  null
  
)

export default component.exports